import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const PROFORMA_HEADERS = [
  "Property Id",
  "Property Name",
  "Property Type",
  "Currency",
  "Net Rent Passing",
  "Rental Value",
  "Gross Value",
  "Capital Expenditure",
  "Acquisition Costs",
  "Net Value",
  "Say Value",
  "NumberOfTenants",
  "InitialYieldValuation",
  "InitialYieldContracted",
  "Nominal Equivalent Yield",
  "True Equivalent Yield",
  "Reversionary Yield",
  "Terminal Cap Rate",
  "Discount Rate",
  "Assumed Holding Period",
  "Growth Rates",
  "Net Exit Value",
  "Forward Initial Yield",
];

// Sample row aligned to Properties class datatypes
const PROFORMA_SAMPLE_ROW = [
  "PROP-001",       // propertyId: string
  "Sample Property",// propertyName: string
  "Office",         // propertyType: string
  "USD",            // currency: string
  1500000,          // netRentPassing: number
  1750000,          // rentalValue: number
  25000000,         // grossValue: number
  500000,           // capitalExpenditure: number
  250000,           // acquisitionCosts: number
  24250000,         // netValue: number
  24000000,         // sayValue: number
  10,               // numOfTenants: number
  5.5,              // initialYieldValuation: number
  5.2,              // initialYieldContracted: number
  5.8,              // nominalEquivalentYield: number
  5.9,              // trueEquivalentYield: number
  6.1,              // reversionaryYield: number
  5.75,             // terminalCapRate: number
  7.0,              // discountRate: number
  10,               // assumedHoldingPeriod: number
  2.5,              // growthRates: number
  22000000,         // netExitValue: number
  5.3,              // forwardInitialYield: number
];

export const downloadGlobalProformaTemplate = () => {
  const wb = XLSX.utils.book_new();
  const wsData = [PROFORMA_HEADERS, PROFORMA_SAMPLE_ROW];
  const ws = XLSX.utils.aoa_to_sheet(wsData);

  // Set column widths for readability
  ws["!cols"] = PROFORMA_HEADERS.map((h) => ({ wch: Math.max(h.length + 2, 15) }));

  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  const wbOut = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([wbOut], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, "Global Proforma-sample.xlsx");
};
